import React, { useState } from 'react';

import ViewButton from '../../elements/ViewButton';

import SlidersApi from 'Api/CRM/Modules/SlidersApi';
import Slider from 'Api/Models/Slider';
import Card from 'crm/elements/common/Card';
import TableHead from 'crm/elements/common/TableHead';
import TableLoader from 'crm/elements/common/TableLoader';
import { PERMISSION } from 'crm/helpers/Permissions';
import useOnce from 'crm/hooks/useOnce';

function SliderList() {
    const [sliders, setSliders] = useState<Slider[]>([]);

    useOnce(() => SlidersApi.getAllSliders().then(setSliders));

    return (
        <Card title="All sliders">
            <TableLoader isLoading={!sliders.length}>
                <table className="table">
                    <TableHead>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Slug</th>
                        <th>Slides count</th>
                        <div />
                    </TableHead>
                    <tbody>
                        {sliders.map((slider) => (
                            <tr key={slider.id}>
                                <td>{slider.id}</td>
                                <td>{slider.name}</td>
                                <td>{slider.slug}</td>
                                <td>{slider.slider_items_count}</td>
                                <td>
                                    <ViewButton
                                        url={`/slider/${slider.id}`}
                                        permissions={[PERMISSION.VIEW_SLIDER_ITEM]}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </TableLoader>
        </Card>
    );
}

export default SliderList;
